export default (theme) => ({
  root: {},
  dialogTitle: {
    '& h6': {
      fontSize: '20px'
    }
  },
  dialogLoader: {
    marginTop: theme.spacing.unit * 2
  },
  dialogForm: {
    marginTop: theme.spacing.unit * 2
  },
  textField: {
    width: '100%'
  },
  confirmButton: {
    borderColor: theme.palette.danger.main + '!important',
    color: theme.palette.danger.main + '!important',
    '&:hover': {
      backgroundColor: theme.palette.danger.light + '!important'
    }
  },
  submitError: {
    color: theme.palette.danger.main,
    alignText: 'center',
    marginBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2
  }
});
